// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CollectiblesWrapper_wrapper__2rnJY","relative":"CollectiblesWrapper_relative__3xo9S","collectiblesWrapper":"CollectiblesWrapper_collectiblesWrapper__3xxKq"};